// Shared section heading for the one-page store: a numbered step badge + h4.
// Keeps the heading hierarchy consistent (section = h4, sub-block = h6).
const SectionTitle = ({ step, children, className = '' }) => (
  <h4 className={`op-title ${className}`.trim()}>
    <span className="op-step-badge" aria-hidden="true">
      {step}
    </span>
    {children}
  </h4>
);

export default SectionTitle;
